import { render, staticRenderFns } from "./FreeBuddhism.vue?vue&type=template&id=149cc4d8&scoped=true"
import script from "./FreeBuddhism.vue?vue&type=script&lang=js"
export * from "./FreeBuddhism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149cc4d8",
  null
  
)

export default component.exports